module.exports = __webpack_public_path__ + "static/media/arbre.c4f57658.jpg";